import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { DatePicker, Select, Table } from "antd";
import config from "../../../config";
import authHeader from "../../Authentication/authHeader";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

export default function ItemWiseSalesList({ tabChange }) {
  dayjs.extend(utc);
  dayjs.extend(timezone);
  const TIMEZONE = "Asia/Dhaka";
  const { Option } = Select;
  const { RangePicker } = DatePicker;
  const [invoiceLists, setInvoiceLists] = useState([]);
  const [salesLoading, setSalesLoading] = useState(false);
  const [centerList, setCenterList] = useState([]);
  const [centerIds, setCenterIds] = useState([]);
  const [userProfile, setUserProfile] = useState(
    JSON.parse(localStorage.getItem("userProfile"))
  );
  const [selectedCenter, setSelectedCenter] = useState("");
  const [selectedDateRange, setSelectedDateRange] = useState([]);

  const handleSalesDateRage = (value) => {
    if (Array.isArray(value) && value.length === 2 && value[0] && value[1]) {
      let startDate = dayjs.tz(value[0], TIMEZONE).startOf("day");
      let endDate = dayjs.tz(value[1], TIMEZONE).endOf("day");

      setSelectedDateRange([
        startDate.format("YYYY-MM-DDTHH:mm:ssZ"),
        endDate.format("YYYY-MM-DDTHH:mm:ssZ"),
      ]);
    } else {
      setSelectedDateRange(null);
    }
  };

  const handleCenter = (value) => {
    setSelectedCenter(value);
  };

  const fetchData = async () => {
    try {
      setSalesLoading(true);
      const response = await axios.get(
        `${config.baseUrl}/inventory/sales_consolidated_list/`,
        {
          headers: authHeader(),
          params: {
            dateRange: selectedDateRange,
            center_id: selectedCenter,
          },
        }
      );
      const resData = Array.isArray(response?.data) ? response?.data : [];
      setInvoiceLists(resData);
    } catch (error) {
      Swal.fire({
        title: "Error",
        text: error,
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setSalesLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [selectedDateRange, selectedCenter, tabChange]);

  useEffect(() => {
    axios
      .get(`${config.baseUrl}/inventory/center_list/`, {
        headers: authHeader(),
      })
      .then((response) => {
        setCenterList(response?.data);
        const employeeIds = response?.data?.map(
          (center) => center?.center?.employee_id
        );
        setCenterIds(employeeIds);
      })
      .catch((error) => {
        Swal.fire({
          title: "Error",
          text: error,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  }, []);

  const salesColumn = [
    {
      title: "Product Name",
      dataIndex: "product__product_name",
    },
    {
      title: "Total Quantity",
      render: (record) =>
        record?.total_sale_quantity !== undefined &&
        record?.total_sale_quantity !== null
          ? Number(record.total_sale_quantity.toFixed(2)).toLocaleString()
          : "0.00",
    },
    {
      title: "Avg. Sale Price",
      render: (record) =>
        record?.avg_sale_price !== undefined && record?.avg_sale_price !== null
          ? Number(record.avg_sale_price).toFixed(2)
          : "0.00",
    },
    {
      title: "Total",
      render: (record) => {
        const qty = Number(record?.total_sale_quantity || 0);
        const price = Number(record?.avg_sale_price || 0);
        const total = qty * price;
        return total.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      },
    },
  ];

  const getColumnTotal = (data, key) => {
    return data
      .reduce((sum, item) => sum + (Number(item[key]) || 0), 0)
      .toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
  };

  const getGrandTotal = (data) => {
    return data
      .reduce(
        (sum, item) =>
          sum +
          (Number(item.total_sale_quantity) || 0) *
            (Number(item.avg_sale_price) || 0),
        0
      )
      .toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
  };

  return (
    <>
      <div className="farmerDashboard">
        <div className="shadow-sm p-3">
          <div className="m-2 mt-4 d-flex justify-content-between align-items-center">
            <div>
              {centerIds?.includes(userProfile?.employee_id) ? null : (
                <Select
                  placeholder="Select Center"
                  className="me-3"
                  onChange={handleCenter}
                  style={{ width: "200px" }}
                >
                  <Option value="">All Center</Option>
                  {centerList?.map((center) => (
                    <Option
                      value={center?.center?.employee_id}
                      key={center?.center?.employee_id}
                    >
                      {center?.center_name}
                    </Option>
                  ))}
                </Select>
              )}
              <RangePicker
                onChange={handleSalesDateRage}
                value={
                  selectedDateRange
                    ? selectedDateRange.map((date) => dayjs(date))
                    : null
                }
                style={{ width: "320px" }}
              />
            </div>
          </div>
          <Table
            columns={salesColumn}
            dataSource={invoiceLists}
            loading={salesLoading}
            rowKey={(record) => record?.sales_id}
            size="small"
            pagination={false}
            summary={(pageData) => (
              <Table.Summary.Row>
                <Table.Summary.Cell index={0}>
                  <strong>Total</strong>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={1}>
                  <strong>
                    {getColumnTotal(pageData, "total_sale_quantity")}
                  </strong>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2} colSpan={1}></Table.Summary.Cell>
                <Table.Summary.Cell index={3}>
                  <strong>{getGrandTotal(pageData)}</strong>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            )}
          />
        </div>
      </div>
    </>
  );
}
